// Componente SEO reutilizable — usa react-helmet-async
import { Helmet } from 'react-helmet-async';

const DEFAULT_IMAGE = 'https://rpiefjkllqtieohnybfy.supabase.co/storage/v1/object/public/media/carousel/1773697976459-20-anos-de-exp.png';
// URL base por entorno: usa REACT_APP_SITE_URL si existe, si no el dominio canonico
const BASE_URL = process.env.REACT_APP_SITE_URL || 'https://americanenglishforbusiness.com';

export default function SEO({
  title,
  description,
  image = DEFAULT_IMAGE,
  url = BASE_URL,
  type = 'website',
}) {
  const fullTitle = title
    ? title
    : 'Cursos de Inglés en Costa Rica | Academia American English';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="es-CR" />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="es_CR" />
      <meta property="og:site_name" content="American English For Business" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
